'use client';

import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import { useState } from 'react';

export function QueryProvider({ children }: { children: React.ReactNode }) {
    const [queryClient] = useState(() => new QueryClient({
        defaultOptions: {
            queries: {
                staleTime: 5 * 60 * 1000, // 5 minutes - data stays fresh
                gcTime: 10 * 60 * 1000, // 10 minutes - cache retention (formerly cacheTime)
                refetchOnWindowFocus: false, // Don't refetch on window focus
                retry: 1, // Retry failed requests once
            },
        },
    }));

    return (
        <QueryClientProvider client={queryClient}>
            {children}
        </QueryClientProvider>
    );
}
